import { call, put, select } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import {
  filePageChanged,
  loaderDisplayChanged,
  previewPageChanged,
  selectCurrentActiveFileId,
  selectActiveContentPage,
  selectIsPreviewActive,
} from 'features/content-library/contentLibrarySlice';
import { contentLibraryChangeFilePageRequested } from 'features/content-library/actions';
import { requestContentWhiteboardData } from 'features/content-whiteboard/actions';
import { contentBoard } from 'features/content-whiteboard/utils/contentBoardStateManager';
import {
  lockedContentChanged,
  selectLockedContent,
} from 'features/layout/features/content/contentSlice';
import { ContentData } from 'features/layout/features/content/types';

export function* changeContentLibraryFilePageSaga(
  action: ReturnType<typeof contentLibraryChangeFilePageRequested>
) {
  const { id, page } = action.payload;

  const isPreviewActive: boolean = yield select(selectIsPreviewActive);
  const currentPage: number = yield select(selectActiveContentPage, isPreviewActive);

  if (currentPage === page) {
    return;
  }

  const currentActiveFileId: string | null = yield select(selectCurrentActiveFileId);

  yield call(contentBoard.clean);

  if (!isPreviewActive && currentActiveFileId === id) {
    yield put(loaderDisplayChanged(true));

    yield call(SignalingSocket.send, {
      event: 'changeLibraryFilePage',
      data: {
        id,
        page,
      },
    });

    const lockedContent: ContentData | null = yield select(selectLockedContent);

    if (lockedContent && lockedContent.type === 'file' && lockedContent.id === id) {
      yield put(lockedContentChanged({ ...lockedContent, page }));
    }
  } else {
    yield put(requestContentWhiteboardData({ id, page }));

    if (isPreviewActive) {
      yield put(previewPageChanged({ id, page }));
      return;
    }

    yield put(filePageChanged({ id, page }));
  }
}
